import { render } from "./TableListKapalCurrentWPP.vue?vue&type=template&id=fdc35712"
import script from "./TableListKapalCurrentWPP.vue?vue&type=script&lang=js"
export * from "./TableListKapalCurrentWPP.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__